import { takeLatest } from 'redux-saga/effects';
import { SET_PARAM_PROXY_PREFIX } from '@corefront/redux-aba';

export function changeWebpackPublicPath(action = { payload: '' }) {
  const { payload } = action;

  // eslint-disable-next-line
  __webpack_public_path__ =
    process.env.NODE_ENV === 'production'
      ? `${payload}/assets/${process.env.REACT_APP_VERSION}/`
      : `${payload}/`;
}

export function* handleWebpackPublicPath() {
  yield takeLatest(SET_PARAM_PROXY_PREFIX, changeWebpackPublicPath);
}
